import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { AutocompleteComponent } from '../../../common/autocomplete/autocomplete.component';
import { YesNoAny } from '../../../models/enums';
import { AdvancedEquipmentConditions } from '../../../models/filter-models';
import { FormsModule } from '@angular/forms';
import { ItemDataService } from '../../../services/item-data.service';
import { BaseComponent } from '../../../common/base.component';
import { TooltipWrapperComponent } from "../../../common/tooltip-wrapper/tooltip-wrapper.component";

@Component({
  selector: 'app-advanced-equipment-conditions',
  imports: [SelectComponent, SelectOptionComponent, AutocompleteComponent, FormsModule, TooltipWrapperComponent, TooltipWrapperComponent],
  templateUrl: './advanced-equipment-conditions.component.html',
  styleUrl: './advanced-equipment-conditions.component.scss'
})
export class AdvancedEquipmentConditionsComponent extends BaseComponent {
  @Input({ required: true }) isArmour!: boolean;
  @Input({ required: true }) advancedConditions!: AdvancedEquipmentConditions;
  @Input({ required: true }) isActive!: boolean;

  @Output() updateFilterEmitter = new EventEmitter<void>();

  YesNoAny = YesNoAny;

  influences: { name: string, image: string }[] = [];
  syndicateMembers!: { name: string, image?: string }[];

  constructor(private itemDataService: ItemDataService) {
    super();
    this.influences = this.itemDataService.getInfluences();
    this.syndicateMembers = this.itemDataService.getAllSyndicateMembers().filter(m => m.name !== 'All');
  }

  toggleInfluenced() {
    this.advancedConditions.hasInfluence = !this.advancedConditions.hasInfluence;
    if (!this.advancedConditions.hasInfluence) {
      delete this.advancedConditions.influences;
    }
    this.updateFilter();
  }

  toggleFractured() {
    this.advancedConditions.fractured = !this.advancedConditions.fractured;
    this.updateFilter();
  }

  toggleSynthesised() {
    this.advancedConditions.synthesised = !this.advancedConditions.synthesised;
    this.updateFilter();
  }

  toggleVeiled() {
    this.advancedConditions.veiled = !this.advancedConditions.veiled;
    if (!this.advancedConditions.veiled) {
      delete this.advancedConditions.veiledOfSyndicateMembers;
    }
    this.updateFilter();
  }

  updateFilter() {
    this.updateFilterEmitter.emit();
  }
}
